import React from "react";
import { NotificationListPage } from "../../Components/dashboard";

const AdminNotificationList = () => {
  return <NotificationListPage role="admin" />;
};

export default AdminNotificationList;
